import { render, staticRenderFns } from "./AdminQuotesScreen.vue?vue&type=template&id=af6ad9cc&scoped=true&"
import script from "./AdminQuotesScreen.vue?vue&type=script&lang=js&"
export * from "./AdminQuotesScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6ad9cc",
  null
  
)

export default component.exports